/* eslint-disable no-param-reassign */
import AdminAnalyticsApi from '@/api/adminAnalytics'
import sentry from '@/services/sentry'

const SET_LOADING = 'SET_LOADING'

const _state = {
  isLoading: false,
}

const getters = {
  isLoading: (state) => state.isLoading,
}

const actions = {
  async sendAdminAnalyticsFeatureRequestAction({ commit }, requestData) {
    try {
      commit(SET_LOADING, true)
      return await AdminAnalyticsApi.sendFeatureRequest(requestData)
    } catch (error) {
      sentry.captureException(error)
      throw error
    } finally {
      commit(SET_LOADING, false)
    }
  },
}

const mutations = {
  [SET_LOADING](state, isLoading) {
    state.isLoading = isLoading
  },
}

const adminAnalytics = {
  namespaced: true,
  state: _state,
  getters,
  actions,
  mutations,
}

export default adminAnalytics
